<template>
  <div>
    <div v-if="successfully_feedback === false">
      <div id="url_expired" style="text-align: center; width: 90%;">
        <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
      <div id="url_valid">
        <div style="text-align: center;">
          <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
          <div>
          {{userDetails.address}}</div>
          *****<br>
          <strong>{{apiDataObj.titleMsg}}</strong><br><br>
          <ul id="example-1">
            <li v-for="item in items">
              {{ item }}
            </li>
          </ul>
          <div v-if="pre_prod === true">
            <input class="switch" value="Switch To Postpaid" type="button" v-on:click="switchToPostpaid">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        urlInterface: [],
        apiDataObj: [],
        userDetails: [],
        disagreeResponse: [],
        successfully_feedback: false,
        pre_prod: false,
        items: null
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('sw?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'switch_subscription':
              this.apiDataObj.userId = response.data.action_response.user_id
              this.items = response.data.action_response.prepaid_subs_product_list
              // this.items = ['Pro1','Pro2']
              this.apiDataObj.isPreProds = response.data.action_response.is_pre_prods
              if (this.apiDataObj.isPreProds === 1) {
                this.apiDataObj.titleMsg = 'Here are your all prepaid subscription if you want to switch to Postpaid then press below'
                this.pre_prod = true
              } else {
                this.apiDataObj.titleMsg = 'You have not any prepaid product'
              }
              this.userInfo()
              break
            default:
              break
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      userInfo () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      switchToPostpaid () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('user_id', this.apiDataObj.userId)
        axios({
          url: process.env.BASE_API + '/accounts/update-url-user-response',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.disagreeResponse = {}
          if (response.data.status === '000000') {
            this.apiDataObj.titleMsg = 'You have successfully changed your all prepaid subscription to Postpaid'
            this.pre_prod = false
            this.items = null
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.switch {background-color: #3CB6C3; padding: 3% 20% 3% 20%; margin-bottom: 40%; color: white; border: none; border-radius: 5% 5% 5% 5%;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Sw.vue